import React, { Component } from 'react';

import Header from '../../containers/Header';
import Footer from '../../containers/Footer';

class Layout extends Component {
    render() {
        let content = null
        content = <>
            <Header />
            {this.props.children}
            <Footer />
        </>

        return (
            <>
                {content}
            </>
        )
    }
}

export default Layout;